import Twitter from '@intercom/embercom-composer/blocks/types/twitter-follow-button';
import focusInput from '@intercom/embercom-composer/lib/focus-input';
import $ from 'jquery';
import Em from 'ember';
export default Em.Component.extend({
  classNames: ['ic-popup', 'ic-popup-left', 'ic-popup-short', 'is-light-theme', 'composer-twitter-inserter'],
  didInsertElement() {
    this._super(...arguments);
    focusInput($('input:first', this.element));
  },
  actions: {
    insert(username) {
      if (!Em.isEmpty(username)) {
        let block = Twitter.create({
          config: this.get('config'),
          username
        });
        let options = {
          index: this.get('hoverCoordinates.insertionIndex'),
          selectNewBlock: false
        };
        this.insertBlock(block, options);
      }
    }
  }
});